 
 
import moment from "moment";
import {
  React,
  useEffect,
  useState,
  Fragment,
  useCallback,
  useRef,
  useMemo,
} from "react";

import cogoToast from "cogo-toast";
import {
  SUCCESS_RESULT,
  TEMPLATES_URL,
  ENDPOINTS,
  LOCAL_PARAMS,
} from "../../Constants";
import { getTemplateByName, genericPost, genericGet } from "../../services/Api";
import {
  EbmsLoading,
  localizeData,
  getLocalizeData,
  resetLocalizeData,
  isObjectEmpty,
  log,
  getUniqueString,
} from "../../services/Utils";

import { Spinner } from "reactstrap";
import { useHistory, Link, useParams } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, Table, Button } from "reactstrap";
// import * as d3 from "d3";
import "./style.css";
import * as FaIcons from "react-icons/fa";
import * as SurveyCore from "survey-core";
import { Survey } from "survey-react-ui";
import "survey-core/defaultV2.css";
import "survey-creator-core/survey-creator-core.min.css";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { FileSaver, saveAs } from "file-saver";
import * as Alerts from "../customs/Alerts";
SurveyCore.StylesManager.applyTheme("defaultV2");
const IdDetails = () => {
  const [isLoading, setIsLoading] = useState(false);
  // const [user, setUser] = useState({});
  const [surveyModel, setSurveyModel] = useState(new SurveyCore.Model({}));
  const [surveyDetails, setSurveyDetails] = useState({});
  const [IdData, setIdData] = useState({});
  const [photo, setPhoto] = useState(null);
  const params = useParams();
  const [error, seterror] = useState(null)
  let startedAt = moment(new Date(), "YYYY-mm-D H:mm:ss");
  let surveyResponses = {};
  let syncToken = getUniqueString(32);

 

  const loadIdInfo = () => {
    if (isObjectEmpty(params, "id")) {
      cogoToast.error(
        "Warning!! Invalid request. Check the link you are loading and try again.",
        {}
      );
      return;
    }
    setIsLoading(true);
    genericPost(ENDPOINTS.ID_DETAILS, { link_id: params.id })
      .then((res) => {
        if (res.status == 200) {
          if (res.data.status == SUCCESS_RESULT) {

            let data=res.data["data"];
            // data.status=10003;  
            setIdData(data);
            setPhoto(res.data["data"].photo);
          } else {
            seterror(res.data.message)
            cogoToast.error(res.data.message, {});
          }
        } else {
          cogoToast.error("Connection error. Please try again.", {});
          seterror(res.data.message)

        }
        setIsLoading(false);
      })
      .catch((err) => {
        // log("Error:: ");
        // log(err);
        setIsLoading(false);
        cogoToast.error("Critical error occurred. Please try again.", {});
      });
  };

  useEffect(() => {
    document.title = "STAFF ID VERIFICATION";
    loadIdInfo();
    
  }, []);


  if (IdData?.status && IdData?.status!=10001)
  return (
    <div style={{ marginRight: "10px", marginLeft: "10px" }} className="row">
      <center>
        <br/>
        <br/>
        <br/>
        <img src="/images/failure.png" alt=" " style={{ width: 100 }} />

        <br/>
        <br/>
        <br/>
        <h1>
        <div class="pull-center">
          <h3 style={{ color: "#ff0000" }}>{IdData?.status==10002 && <>This Staff ID has been cancelled
 </>}
          {IdData?.status==10003 && <>This ID has expired
 </>}
          </h3>
        </div>
        </h1>
      </center>
    </div>
  );


  if (error)
    return (
      <div style={{ marginRight: "10px", marginLeft: "10px" }} className="row">
        <center>
          <br/>
          <br/>
          <br/>
          <img src="/images/failure.png" alt=" " style={{ width: 100 }} />

          <br/>
          <br/>
          <br/>
          <h1>
          <div class="pull-center">
            <h3 style={{ color: "#ff0000" }}>{error}</h3>
          </div>
          </h1>
        </center>
      </div>
    );
  else
    return (
      <div>
 
        
  {isLoading ?    <center>
            <EbmsLoading data={isLoading} />
          </center> :
        <div
          style={{ marginRight: "10px", marginLeft: "10px" }}
          className="row"
        >
       
          <div
            style={{ margin: "20px", backgroundColor: "#ffffff" }}
            class="card_body"
          >
            <table>
              <tr>
                <td>
                  <img  src={"data:image/png;base64, "+IdData.photo} className="photo" />
                </td>

                <td>
                  <img
                    src="https://irw-ebms-ear.co.ke/images/logo.jpg"
                    className="photo"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <b>{IdData.staff_ame}</b>
                </td>
                <td></td>
              </tr>
              <tr>
                <td>ID No</td>
                <td>
                  <b> {IdData.staff_id}</b>
                </td>
              </tr>
              <tr>
                <td>Title</td>
                <td>
                  <b> {IdData.role_name}</b>
                </td>
              </tr>
              <tr>
                <td>Dept</td>
                <td>
                  <b> {IdData.department}</b>
                </td>
              </tr>
              <tr>
                <td>Office</td>
                <td>
                  <b> {IdData.office_name}</b>
                </td>
              </tr>
              <tr>
                <td>Blood</td>
                <td>
                  <b> {IdData.blood_group}</b>
                </td>
              </tr>
              <tr>
                <td>Expiaray Date</td>
                <td>
                  <b> {IdData.expiry_date}</b>
                </td>
              </tr>
            </table>
            <hr />
            <center>
              <h1>
                <img src="/images/success.png" alt=" " style={{ width: 100 }} />
                <br />
                THIS ID IS VALID
              </h1>
            </center>
          </div>
        </div>
        }
      </div>
    );
};

export default IdDetails;
